export default __webpack_public_path__ + "static/media/blue4.670049ae.png";